<template>
  <div>
    <b-list-group>
      <b-list-group-item
        v-for="(record, index) in records"
        :key="record.id"
        class="flex-column align-items-start mb-2 main-column"
      >
        <div
          class="d-flex w-100 justify-content-between align-items-center reference"
          @click="toggleExpanded(record.id)"
        >
          <span class="cursor-pointer">ID: {{ record.id }}, {{ record.name }}</span>
          <div class="d-flex align-items-center">
            <template v-if="allowReorder">
              <i
                class="bx bx-up-arrow-alt cursor-pointer mr-1 text-secondary"
                title="Поднять выше"
                @click.stop="moveOrder(record, 'up', index)"
              ></i>
              <i
                class="bx bx-down-arrow-alt cursor-pointer mr-2 text-secondary"
                title="Опустить ниже"
                @click.stop="moveOrder(record, 'down', index)"
              ></i>
            </template>
            <i class="bx bx-edit cursor-pointer mr-2" @click.stop="showEdit(record)" title="Изменить название"></i>
            <i
              class="bx bx-trash cursor-pointer mr-2 text-danger"
              title="Удалить свойство"
              @click.stop="confirmDelete(record)"
            ></i>
            <b-badge :variant="record.children && record.children.length ? 'primary' : 'secondary'" pill>
              {{ (record.children && record.children.length) || 0 }}
            </b-badge>
          </div>
        </div>
        <div
          v-if="record.children && record.children.length"
          class="properties mt-3"
          v-show="isExpanded(record.id)"
        >
          <Bdr2026NestedRecords
            :records="record.children"
            :level="level + 1"
            :parent-options="parentOptions"
            :expanded-ids="expandedIds"
            :allow-reorder="true"
            @update-item="$emit('update-item')"
            @toggle-expanded="$emit('toggle-expanded', $event)"
            @edit="$emit('edit', $event)"
          />
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>

<script>
import { API_BDR2026_DICTIONARY } from '@/constants';

export default {
  name: 'Bdr2026NestedRecords',
  props: {
    records: { type: Array, required: true },
    level: { type: Number, default: 1 },
    parentOptions: { type: Array, default: () => [] },
    expandedIds: { type: Object, default: () => ({}) },
    allowReorder: { type: Boolean, default: true }
  },
  data() {
    return {
      apiDictionary: API_BDR2026_DICTIONARY
    };
  },
  methods: {
    isExpanded(id) {
      return !!this.expandedIds[id];
    },
    toggleExpanded(id) {
      this.$emit('toggle-expanded', id);
    },
    showEdit(record) {
      this.$emit('edit', {
        id: record.id,
        name: record.name,
        parent_id: record.parent_id || 0
      });
    },
    confirmDelete(record) {
      this.$swal.fire({
        title: 'Удалить свойство?',
        html: 'Убедитесь, что по этой строке <b>нет цифр</b> (данных в таблице бюджета).<br>Удалить запись из словаря?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        confirmButtonColor: '#dc3545',
        cancelButtonColor: '#6c757d'
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(`${this.apiDictionary}/${record.id}`).then(() => {
            this.$emit('update-item');
            if (this.$bvToast) {
              this.$bvToast.toast('Запись удалена', { variant: 'success', title: 'Словарь таблицы' });
            }
          }).catch(err => {
            const msg = (err.response && err.response.data && err.response.data.message) || err.message || 'Ошибка удаления';
            if (this.$bvToast) {
              this.$bvToast.toast(msg, { variant: 'danger', title: 'Словарь таблицы' });
            }
          });
        }
      });
    },
    moveOrder(record, direction, index) {
      if (direction === 'up' && index === 0) return;
      if (direction === 'down' && index >= this.records.length - 1) return;
      const url = `${this.apiDictionary}/${record.id}/reorder`;
      axios.post(url, { direction }).then(() => {
        this.$emit('update-item');
      }).catch(err => {
        this.$bvToast && this.$bvToast.toast((err.response && err.response.data && err.response.data.error) || 'Ошибка смены порядка', {
          variant: 'danger',
          title: 'Словарь'
        });
      });
    }
  }
};
</script>
